import ScrollReveal from 'scrollreveal';

ScrollReveal().reveal('.js-sr', {
  interval: 150,
  distance: '10px',
  duration: 750,
});
